import { type ReactNode } from 'react';
import { Icon, type IconTypes } from '@ics-portal/guardian';
import s from '../SummaryCards.module.scss';

export interface SummaryCardTitleProps {
    icon: IconTypes;
    iconClassName: string;
    title: string;
}

export function SummaryCardTitle(props: SummaryCardTitleProps): ReactNode {
    const { icon, iconClassName, title } = props;
    return (
        <div className="flex gap-2 align-items-center">
            <Icon fontSize="normal" name={icon} className={iconClassName} />
            <h4 className={s.title}>{title}</h4>
        </div>
    );
}
